module.exports = __webpack_public_path__ + "static/media/iconSaveDate.2014cc14.svg";